<template>
  <div class="dropdown">
    <slot name="trigger">
      <button
          class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end"
          :id="`trigger_${bsid}`"
          data-bs-toggle="dropdown"
          aria-expanded="false"
      >
        <slot name="label">
          <i
              class="fa fa-ellipsis-h"
          >
          </i>
        </slot>
      </button>
    </slot>
    <div class="dropdown-menu" :id="`body_${bsid}`" :aria-labelledby="bsid" role="menu">
      <slot name="menu-items">
        <!--          please feel free to override menu-items slot when necessary        -->
        <slot name="menu-item" v-for="item in items" :item="item">
          <a class="dropdown-item px-3 cursor-pointer" @click="item.handler()">{{ item.label }}</a>
        </slot>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bsid: {
      default: () => $_.random(true)
    },
    items: []
  },
  data() {
    return {}
  }
}
</script>